// extracted by mini-css-extract-plugin
export default {"input":"add_input__coubn","requiredtext":"add_requiredtext__uk4+C"};